import { useEffect, useCallback } from 'react'
import { supabase } from '@/integrations/supabase/client'

export function useOperationCleanup() {
  const cleanupStuckOperations = useCallback(async () => {
    try {
      // Find operations that have been running for more than 30 minutes
      const thirtyMinutesAgo = new Date(Date.now() - 30 * 60 * 1000).toISOString()
      
      const { data: stuckOperations, error: fetchError } = await supabase
        .from('mailbox_bulk_operations')
        .select('*')
        .is('completed_at', null)
        .lt('started_at', thirtyMinutesAgo)

      if (fetchError) {
        console.error('Error fetching stuck operations:', fetchError)
        return
      }

      if (stuckOperations && stuckOperations.length > 0) {
        console.log(`Found ${stuckOperations.length} stuck operations, cleaning up...`)
        
        // Mark them as completed/failed based on their progress
        for (const operation of stuckOperations) {
          const status = operation.successful_count > 0 ? 'completed' : 'timeout'
          
          await supabase
            .from('mailbox_bulk_operations')
            .update({
              completed_at: new Date().toISOString(),
              operation_status: status,
              operation_timeout_at: new Date().toISOString()
            })
            .eq('id', operation.id)
        }
        
        console.log(`Cleaned up ${stuckOperations.length} stuck operations`)
      }
    } catch (error) {
      console.error('Error cleaning up stuck operations:', error)
    }
  }, [])

  // Run cleanup when the hook is first used
  useEffect(() => {
    cleanupStuckOperations()
    
    // Set up periodic cleanup every 5 minutes
    const interval = setInterval(cleanupStuckOperations, 5 * 60 * 1000)
    
    return () => clearInterval(interval)
  }, [cleanupStuckOperations])

  return { cleanupStuckOperations }
}